import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

export const dbmlSchemaPlugin = createPlugin({
  id: 'dbml-schema',
});

export const EntityDbmlContent = dbmlSchemaPlugin.provide(
  createComponentExtension({
    name: 'EntityDbmlContent',
    component: {
      lazy: () =>
        import('./components/EntityDbmlContent').then(m => m.EntityDbmlContent),
    },
  }),
);
